/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-29 17:11:56
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-09 15:31:15
 * @FilePath: \crm-product\found\views\tpm\views\budget\cost_warning\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from '../form';

export default {
  name: 'warning_rules_table',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main-list');
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      this.formConfig = {};
      this.formName = 'Form';
      if (['add', 'view'].includes(val.code)) {
        this.formConfig = {
          code: val.code,
          row,
        };
        if (val.code === 'add') {
          this.modalConfig.title = '新增';
        } else if (val.code === 'view') {
          this.modalConfig.title = '查看';
        }
        this.openFull();
      } else if (val.code === 'enable') {
        if (this.selection.length > 0) {
          this.$confirm('确认要启用吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              request.post('/cps/terminalScanIndicator/enable', this.selection).then((res) => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getList();
                  this.clearSelection();
                }
              });
            });
        } else {
          this.$message('请至少选择一条数据！');
          return false;
        }
      } else if (val.code === 'disable') {
        if (this.selection.length > 0) {
          this.$confirm('确认要禁用吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              request.post('/cps/terminalScanIndicator/disable', this.selection).then((res) => {
                if (res.success) {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getList();
                  this.clearSelection();
                }
              });
            });
        } else {
          this.$message('请至少选择一条数据！');
          return false;
        }
      }
    },
  },
};
